import { createContext } from 'react'

export type AiChatPageContext = {
  documentCollectionId?: string
  recordId?: string
  label?: string
}
export const AiChatNavigationContext = createContext<{
  pathname: string
  setPageContext: (
    context: { pathname: string; details: AiChatPageContext } | null,
  ) => void
} | null>(null)
